module.exports = __webpack_public_path__ + "static/the-sun-does-shine-3e54357d28abdb81d1a82649921812aa.jpg";